<template>
  <b-modal
    :active.sync="active_"
    has-modal-card
    class="import-modal"
    @close="close"
  >
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title has-text-weight-bold">Importer</p>
      </header>
      <section class="modal-card-body">
        <template v-if="activeStep === 0">
          <slot name="step1" />
          <b-field label="CSV File">
            <b-upload v-model="file" class="file-label">
              <span class="file-cta">
                <b-icon class="file-icon" icon="upload"></b-icon>
                <span class="file-label">Select a file</span>
              </span>
              <span class="file-name" v-if="file">
                {{ file.name }}
              </span>
            </b-upload>
          </b-field>
        </template>
        <template v-if="activeStep === 1">
          <table class="table" style="width: 960px">
            <tbody>
              <tr v-for="(row, rowKey) in fileData" :key="rowKey">
                <template v-for="(col, colKey) in row">
                  <th v-if="rowKey == 0" :key="colKey">
                    {{ col }}
                  </th>
                  <td
                    :class="getFileDataColumnClass(colKey)"
                    :key="colKey"
                    v-else
                  >
                    <b-field
                      :type="
                        getFileDataErrorMessage(rowKey, colKey)
                          ? 'is-danger'
                          : ''
                      "
                      :message="getFileDataErrorMessage(rowKey, colKey)"
                    >
                      <b-input v-model="fileData[rowKey][colKey]" />
                    </b-field>
                  </td>
                </template>
              </tr>
            </tbody>
          </table>
        </template>
      </section>
      <footer
        class="modal-card-foot"
        style="display: flex; justify-content: space-between"
      >
        <div>
          <slot name="footer-left" />
        </div>
        <div>
          <b-button @click="close">Cancel</b-button>
          <b-button
            outlined
            type="is-danger"
            @click.prevent="() => activeStep--"
            v-if="activeStep > 0"
          >
            Back
          </b-button>
          <b-button
            outlined
            type="is-success"
            :disabled="!file"
            @click.prevent="reviewFile"
            v-if="activeStep === 0"
          >
            Review
          </b-button>
          <b-button
            outlined
            type="is-success"
            :loading="loading"
            :disabled="fileHasErrors"
            @click.prevent="importFile"
            v-if="activeStep === 1"
          >
            Import
          </b-button>
        </div>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import { parse as parseCsv } from "@/helpers/csv-parser";

export default {
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    validators: {
      type: Object,
      default: () => ({}),
    },
    transformers: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    activeStep: 0,
    active_: false,
    file: null,
    fileReader: null,
    fileData: null,
    errors: {},
    loading: false,
  }),
  computed: {
    fileHasErrors() {
      return !!Object.keys(this.errors).length;
    },
  },
  watch: {
    active(active) {
      this.active_ = active;
    },
    active_(active) {
      this.$emit("update:active", active);
    },
  },
  mounted() {
    this.fileReader = new FileReader();
    this.fileReader.onload = () => {
      let data = this.fileReader.result;
      // if (data.search("\r\n") > -1) {
      //   data = data.split("\r\n");
      // } else {
      //   data = data.split("\n");
      // }
      // data.pop();
      // data = data.map((row) => row.split(",").map((d) => d.replace(/"/g, "")));
      this.fileData = parseCsv(data);
    };
  },
  methods: {
    getFileDataColumnClass(colKey) {
      let columnClass = this.fileData[0][colKey]
        .replace(" ", "-")
        .toLowerCase();
      return `col-${columnClass}`;
    },
    getFileDataErrorMessage(rowKey, colKey) {
      if (this.validators[this.getFileDataColumnClass(colKey)]) {
        const value = this.fileData[rowKey][colKey];
        const error =
          this.validators[this.getFileDataColumnClass(colKey)](value);
        if (error) {
          this.$set(this.errors, `${rowKey}-${colKey}`, error);
        } else {
          this.$delete(this.errors, `${rowKey}-${colKey}`);
        }
        return error;
      }
    },
    close() {
      this.file = null;
      this.activeStep = 0;
      this.loading = false;
      this.active_ = false;
      this.$emit("close");
    },
    reviewFile() {
      this.fileReader.readAsBinaryString(this.file);
      this.activeStep++;
    },
    importFile() {
      if (this.fileHasErrors) return;
      let data = this.fileData;
      data = data
        .map((row, rowKey) => {
          return row.map((col, colKey) => {
            if (
              rowKey != 0 &&
              this.transformers[this.getFileDataColumnClass(colKey)]
            ) {
              return this.transformers[this.getFileDataColumnClass(colKey)](
                col
              );
            }
            col = col.replace(/"/g, "'");
            return `"${col}"`;
          });
        })
        .map((row) => row.join(","));
      data = data.join("\r\n");
      let file = new Blob([data], { type: "text/csv;charset=utf-8;" });
      this.$emit("import", file);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Importer/Importer.vue